import styled from 'styled-components'

export const DropdownSelect = styled.div`
    ${({ maxWidth }) => (
        maxWidth && `max-width: ${maxWidth};`
    )}
`
